export default __webpack_public_path__ + "static/media/monkey9.4191ee8d.jpg";